export const useVatAutofillAddress = () => {

  const isAddressAutofilled = useState('isAddressAutofilled', () => false);

  /**
   * Outlives the notice itself: the hint offering to fill the company details in from the VAT
   * register must not come back once we already did it, not even after the user edits a field.
   * Only a new VAT number or a different address makes the offer relevant again.
   */
  const hasAddressBeenAutofilled = useState('hasAddressBeenAutofilled', () => false);

  const resetAddressAutofill = () => {

    isAddressAutofilled.value = false;
    hasAddressBeenAutofilled.value = false;

  };

  const setAddressAutofilled = () => {

    isAddressAutofilled.value = true;
    hasAddressBeenAutofilled.value = true;

  };

  /**
   * The notice speaks for values the user has not touched, so the first edit of an autofilled
   * field retires it - reverting that field does not bring it back.
   */
  const dismissAutofillNotice = () => {

    isAddressAutofilled.value = false;

  };

  return {
    isAddressAutofilled,
    hasAddressBeenAutofilled,
    resetAddressAutofill,
    setAddressAutofilled,
    dismissAutofillNotice,
  };

};

